import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsShipmentManagementServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsShipmentManagementServices";
import { eiwrsSiteInventoryServices } from "../../../../APIServices/EIWRS/eiwrsSiteInventoryServices";
import { eiwrsDepotManagementServices } from "../../../../APIServices/EIWRS/eiwrsDepotManagementServices";

const AddNewStudySiteShipment = ({ getStudySiteShipmentData, siteList, corierList }) => {
  let { studyId } = useParams();
  const [siteId, setSiteId] = useState("");
  const [depotId, setDepotId] = useState("");
  const [shipmentType, setShipmentType] = useState("");
  const [corierId, setCorierId] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [tempLoggerId, setTempLoggerId] = useState("");
  const [depotList, setDepotList] = useState([]);
  const [kitList, setKitList] = useState([]);
  const [totalKit, setTotalKit] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const addNewStudySiteShipment = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.siteId = siteId;
    userData.depotId = depotId;
    userData.shipmentType = shipmentType;
    userData.totalKit = totalKit;
    userData.corierId = corierId;
    userData.trackingId = trackingId;
    userData.tempLoggerId = tempLoggerId;
    userData.mode = StudyMode;
    let data = await eiwrsShipmentManagementServices.addNewStudySiteShipment(
      userData
    );
    if (data?.statusCode === 200) {
      setSiteId("");
      setDepotId("");
      setTotalKit([]);
      setShipmentType("");
      setCorierId("");
      setTrackingId("");
      setTempLoggerId("");
      getStudySiteShipmentData()
    }
    setButtonLoader(false);
  };

  const getDepotBySite = async () => {
    let data = await eiwrsSiteInventoryServices.getDepotBySite(studyId, siteId)
    setDepotList(data?.data || [])
  }

  useEffect(() => {
    if (siteId) {
      getDepotBySite()
    }
  }, [siteId]);

  const getStudyAvailableKitInDepot = async () => {
    let data = await eiwrsDepotManagementServices.getStudyAvailableKitInDepot(studyId, depotId, StudyMode)
    setKitList(data?.data || [])
  }

  useEffect(() => {
    if (depotId) {
      getStudyAvailableKitInDepot()
    }
  }, [depotId]);

  useEffect(() => {
    setSiteId("");
    setDepotId("");
    setShipmentType("");
    setTotalKit([]);
    setCorierId("");
    setTrackingId("");
    setTempLoggerId("");
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Site <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Select
          value={siteId}
          disabled={siteList?.length === 0}
          onChange={(e) => setSiteId(e.target.value)}
        >
          <option value="">
            Select Site
          </option>
          {siteList?.map((item, index) => (
            <option key={index} value={item.siteId}>
              {item.row?.SITEID}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Depot <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Select
          value={depotId}
          disabled={depotList?.length === 0}
          onChange={(e) => setDepotId(e.target.value)}
        >
          <option value="">
            Select Depot
          </option>
          {depotList?.map((item, index) => (
            <option key={index} value={item.depotId}>
              {item.row?.DEPOTID}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      {depotId &&
        <Form.Group className="mb-1">
          {kitList?.length > 0 ?
            <Form.Label className="mb-1 fw-bold">
              Kits <abbr className="text-danger">*</abbr>
            </Form.Label>
            :
            <Form.Label className="mb-1 fw-bold text-danger">
              Kit Not Available in Selected Depot
            </Form.Label>
          }
          {kitList?.map((item) => (
            <Form.Check
              key={item?.kitId}
              type="checkbox"
              label={`${item?.kitNumber}${item?.columns?.filter(
                (column) => column?.isUnique === "yes"
              )?.length > 0
                  ? ` (${item?.columns
                    ?.filter((column) => column?.isUnique === "yes")
                    ?.map(
                      (data) => `${data?.columnName}: ${data?.columnValue}`
                    )
                    ?.join(", ")})`
                  : ""
                }`}
              onChange={(e) =>
                setTotalKit((prev) =>
                  e.target.checked
                    ? [...prev, item?.kitId]
                    : prev.filter((kit) => kit !== item?.kitId)
                )
              }
            />
          ))}
        </Form.Group>
      }
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Shipiment Type <abbr className="text-danger">*</abbr>
        </Form.Label>
        <Form.Select
          value={shipmentType}
          onChange={(e) => setShipmentType(e.target.value)}
        >
          <option value="">
            Select Shipiment Type
          </option>
          <option value="initial">Initial Shipment</option>
          <option value="resupply">Resupply Shipment</option>
          <option value="emergency">Emergency Shipment</option>
          <option value="replacement">Replacement Shipment</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          Corier
        </Form.Label>
        <Form.Select
          value={corierId}
          onChange={(e) => setCorierId(e.target.value)}
        >
          <option value="">
            Select Corier
          </option>
          {corierList?.map((item, index) => (
            <option key={index} value={item.corierId}>
              {item.row?.CORIERID}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Tracking / AWB No.{" "}
        </Form.Label>
        <Form.Control
          onChange={(e) => setTrackingId(e.target.value)}
          value={trackingId}
          className="br3"
          placeholder="Enter Tracking / AWB No."
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Temp logger Id{" "}
        </Form.Label>
        <Form.Control
          onChange={(e) => setTempLoggerId(e.target.value)}
          value={tempLoggerId}
          className="br3"
          placeholder="Enter Temp logger Id"
          type="text"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!siteId || !depotId || !shipmentType || totalKit?.length === 0 || buttonLoader}
          onClick={addNewStudySiteShipment}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add Shipment"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudySiteShipment;
